import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlayerTypeComponent } from './player-type/player-type.component';
import { AddPlayerComponent } from './add-player.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PlayersListComponent } from './players-list/players-list.component';
import { PipesModule } from '../../pipes/pipes.module';
import { BuiltInModule } from '../../built-in/built-in.module';
import { TooltipModule } from 'ng2-tooltip-directive';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PipesModule,
    BuiltInModule,
    TooltipModule
  ],
  declarations: [
    PlayerTypeComponent,
    AddPlayerComponent,
    PlayersListComponent
  ],
  exports: [
    PlayerTypeComponent,
    AddPlayerComponent
  ]
})
export class AddPlayerModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/add-player/add-player.module.ts